import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const InAppRedirect = () => {
  const [searchParams] = useSearchParams();

  const to = searchParams.get("to");

  useEffect(() => {
    if (to) {
      window.open(decodeURIComponent(to), "_self");
    }
  }, [to]);

  return <></>;
};
